import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { BadgeModule } from 'primeng/badge';
import { Store } from '@ngrx/store';
import { AppState } from '../store/app.reducer';
import { map, Subscription } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { ConnectivityService } from '../services/connectivity.service';
import { NotificationService } from '../services/notification.service';
import { AppModeService } from '../garbage/app-mode.service';

@Component({
    selector: 'app-header',
    imports: [RouterLink, RouterLinkActive, ButtonModule, AsyncPipe, TooltipModule, BadgeModule],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit, OnDestroy {
  protected readonly isOnCreatePage = signal(false);
  protected readonly currentEventId = signal<string | null>(null);
  private readonly store = inject(Store<AppState>);
  private readonly router = inject(Router);
  protected readonly connectivity = inject(ConnectivityService);
  protected readonly notificationService = inject(NotificationService);
  protected readonly appMode = inject(AppModeService);
  protected readonly user$ = this.store.select('auth').pipe(map(authState => authState.user));
  private routerSubscription?: Subscription;
  private authSubscription?: Subscription;

  private updateRouteState(url: string) {
    this.isOnCreatePage.set(
      url.includes('/observations/new') || url.includes('/observations/edit')
      || url.includes('/garbage/new') || url.includes('/garbage/edit')
    );
    const eventMatch = url.match(/\/events\/(\d+)\/view/);
    this.currentEventId.set(eventMatch ? eventMatch[1] : null);
  }

  ngOnInit(): void {
    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.updateRouteState(event.urlAfterRedirects);
      }
    });
    this.updateRouteState(this.router.url);

    // Connect to real-time notifications when user is authenticated
    this.authSubscription = this.user$.subscribe((user) => {
      if (user?.token) {
        this.notificationService.connect(user.token);
      } else {
        this.notificationService.disconnect();
      }
    });
  }

  ngOnDestroy(): void {
    this.routerSubscription?.unsubscribe();
    this.authSubscription?.unsubscribe();
    this.notificationService.disconnect();
  }
}
